export function decodeJwtPayload(token: string): Record<string, unknown> | null {
  try {
    return JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
  } catch {
    return null;
  }
}

export function getTokenExpiryMs(token: string | null | undefined): number | null {
  if (!token) return null;
  const payload = decodeJwtPayload(token);
  return typeof payload?.exp === 'number' ? payload.exp * 1000 : null;
}

export function getMinutesUntilExpiry(token: string | null | undefined): number | null {
  const expiryMs = getTokenExpiryMs(token);
  if (expiryMs == null) return null;
  const ms = expiryMs - Date.now();
  if (ms <= 0) return 0;
  return Math.ceil(ms / 60_000);
}
